export const convertRealmToRegion = (realm) => {
  switch (realm) {
    case "USAmazon":
      return "NA";
    case "EUAmazon":
      return "EU";
    case "JPAmazon":
      return "FE";
  }
};
